import {
  DollarSign,
  ShoppingBag,
  Package,
  CheckCircle,
  Plus,
} from "lucide-react";
import { MetricCard } from "../../components/dashboard/metric-card";
import { RecentOrders } from "../../components/dashboard/shop/recent-orders";
import { Button } from "../../components/ui/button";
import { useEffect, useState } from "react";
import { AddProductForm } from "../../components/dashboard/shop/add-product-form";
import { ProductDetails } from "../../components/dashboard/shop/product-details";
import { getDashboardStats } from "../../services/api";
import { toast } from "react-toastify";

type View = 'list' | 'add' | 'edit' | 'details'

const Shop = () => {
  const [view, setView] = useState<View>('list')
  const [selectedProduct, setSelectedProduct] = useState<any>(null)
  const [stats, setStats] = useState({
    scheduled_bookings: 0,
    total_orders: 0,
    total_bookings: 0,
    completed_bookings: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Fetch dashboard stats on component mount
  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await getDashboardStats();
      setStats(response.data.data); // Adjust based on API response structure
    } catch (error) {
      console.error('Failed to fetch dashboard stats:', error);
      setError('Failed to fetch dashboard stats. Please try again.');
      toast.error('Failed to fetch dashboard stats. Please try again.', {
        position: 'top-center',
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (view === 'add') {
    return (
      <div className="p-8">
        <AddProductForm onBack={() => setView('list')} />
      </div>
    )
  }

  if (view === 'edit' && selectedProduct) {
    return (
      <div className="p-8">
        <AddProductForm 
          onBack={() => setView('list')} 
          editProduct={selectedProduct}
        />
      </div>
    )
  }
  
  return (
    <div className="p-8">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-semibold mb-1">Manage your shop</h1>
          <p className="text-muted-foreground">
            Track your inventory, orders, and sales performance
          </p>
        </div>
        <Button
          className="bg-[#B87775] hover:bg-[#B87775]/90 text-white"
          onClick={() => setView("add")}
        >
          <Plus className="mr-2 h-4 w-4" />
          ADD PRODUCT
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <MetricCard title="Scheduled Bookings" value={stats.scheduled_bookings} icon={DollarSign} />
        <MetricCard title="Bookings" value={stats.total_bookings} icon={ShoppingBag} />
        <MetricCard title="Completed Bookings" value={stats.completed_bookings} icon={Package} />
        <MetricCard title="Orders" value={stats.total_orders} icon={CheckCircle} />
      </div>

      <RecentOrders />
    </div>
  );
};

export default Shop;
